import React from 'react';
import { Zap, Star, Building2 } from 'lucide-react';
import type { SubscriptionPlanType } from '../../types/payments';

export interface PrepagoPlan {
    id: SubscriptionPlanType;
    name: string;
    price: number;
    messages: number;
    icon: React.ReactNode;
    color: string;
    textColor: string;
    border: string;
    cardBg: string;
    iconBg: string;
    badge: string | null;
    features: string[];
}

export const PREPAGO_PLANS: PrepagoPlan[] = [
    {
        id: 'basic_200',
        name: 'Básico',
        price: 29900,
        messages: 200,
        icon: <Zap className="w-5 h-5" />,
        color: 'bg-[#2ab5a4]',
        textColor: 'text-[#2ab5a4]',
        border: 'border-[#A7E6DE]',
        cardBg: 'bg-[#F2FBF9]',
        iconBg: 'bg-[#D8F3EE]',
        badge: null,
        features: [
            '200 recordatorios automáticos / mes',
            'Automatización desde Google Sheets',
            'Configuración inicial',
            'Soporte básico',
        ],
    },
    {
        id: 'standard_1000',
        name: 'Estándar',
        price: 79900,
        messages: 1000,
        icon: <Star className="w-5 h-5" />,
        color: 'bg-[#a8d754]',
        textColor: 'text-[#86BC2A]',
        border: 'border-[#D7EEAE]',
        cardBg: 'bg-[#FBFEEF]',
        iconBg: 'bg-[#EEF8D9]',
        badge: 'Más popular',
        features: [
            '1.000 recordatorios automáticos / mes',
            'Automatización desde Google Sheets',
            'Configuración inicial',
            'Soporte prioritario',
        ],
    },
    {
        id: 'premium_3000',
        name: 'Avanzado',
        price: 199900,
        messages: 3000,
        icon: <Building2 className="w-5 h-5" />,
        color: 'bg-[#2788b6]',
        textColor: 'text-[#2788b6]',
        border: 'border-[#B9DDF0]',
        cardBg: 'bg-[#F4FAFD]',
        iconBg: 'bg-[#DDEEF7]',
        badge: null,
        features: [
            '3.000 recordatorios automáticos / mes',
            'Automatización desde Google Sheets',
            'Configuración inicial',
            'Soporte prioritario',
            'Mayor capacidad para alto volumen de recordatorios automáticos',
        ],
    },
];

// Must match PAID_SIGNUP_PLANS in backend/core/services/paywall_service.py.
const PLAN_URL_CODES: Record<string, SubscriptionPlanType> = {
    '1': 'basic_200',
    '2': 'standard_1000',
    '3': 'premium_3000',
};
const DEFAULT_PLAN_URL_CODE = '2';

export function planFromUrlCode(code: string | null | undefined): PrepagoPlan {
    const id = PLAN_URL_CODES[(code ?? '').trim()] ?? PLAN_URL_CODES[DEFAULT_PLAN_URL_CODE];
    return PREPAGO_PLANS.find(p => p.id === id)!;
}

export function planUrlCode(id: SubscriptionPlanType): string {
    return Object.keys(PLAN_URL_CODES).find(code => PLAN_URL_CODES[code] === id) ?? DEFAULT_PLAN_URL_CODE;
}

export function planById(id: string | null | undefined): PrepagoPlan | undefined {
    return PREPAGO_PLANS.find(p => p.id === id);
}

export const formatCOP = (val: number) =>
    val.toLocaleString('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 });
